import { createReducer, on } from '@ngrx/store';

import { INotificationsData } from '../../shared/models/NotificacionTendero';
import {
    errorNotifications,
    errorReadNotification,
    getNotifications,
    readNotification,
    resetNotifications,
    resetReadNotification,
    setReadNotification,
    successNotifications,
    successReadNotification,
} from '../actions';


/**
 * Obtiene las notificaciones del usuario
 */
export interface NotificationsState {
    error: Error | null;
    failed: boolean;
    success: boolean;
    loading: boolean;
    notifications: INotificationsData[];
}

export const NotificationsInit: NotificationsState = {
    error: null,
    failed: false,
    success: false,
    loading: false,
    notifications: []
};

const _notificationsReducer = createReducer(NotificationsInit,
    on(getNotifications, state => (
        {
            ...state,
            loading: true,
            success: false,
            failed: false
        }
    )),
    on(successNotifications, (state, { data }) => (
        {
            ...state,
            loading: false,
            success: true,
            notifications: data.notifications || []
        }
    )),
    on(errorNotifications, (state, { payload }) => (
        {
            ...state,
            loading: false,
            success: false,
            failed: true,
            error: { ...payload }
        }
    )),
    on(setReadNotification, (state, { ID_NotificacionTendero }) => (
        {
            ...state,
            loading: false,
            success: true,
            notifications: state.notifications.map(n => {
                if (n.idPushDetail === ID_NotificacionTendero) {
                    return { ...n, view: true };
                }
                return n;
            })
        }
    )),
    on(resetNotifications, state => ({ ...state, ...NotificationsInit }))
);

export function NotificationsReducer(state: any, action: any) {
    return _notificationsReducer(state, action);
}

/**
 * Actualiza Leido de la notificacion del usuario
 */
export interface ReadNotificationState {
    error: Error | null;
    failed: boolean;
    success: boolean;
    loading: boolean;
}

export const ReadNotificationInit: ReadNotificationState = {
    error: null,
    failed: false,
    success: false,
    loading: false
};

const _readNotificationReducer = createReducer(ReadNotificationInit,
    on(readNotification, (state, { api, ID_NotificacionTendero }) => (
        {
            ...state,
            loading: true,
            success: false,
            failed: false,
            credentails: { api, ID_NotificacionTendero }
        }
    )),
    on(successReadNotification, (state, resp) => (
        {
            ...state,
            loading: false,
            success: true,
        }
    )),
    on(errorReadNotification, (state, { payload }) => (
        {
            ...state,
            loading: false,
            success: false,
            failed: true,
            error: { ...payload }
        }
    )),
    on(resetReadNotification, state => ({ ...state, ...ReadNotificationInit }))
);

export function ReadNotificationReducer(state: any, action: any) {
    return _readNotificationReducer(state, action);
}
